var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCruceroIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102.296,
    height: 76.505,
    viewBox: "0 0 102.296 76.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_41",
    "data-name": "Rect\\xE1ngulo 41",
    width: 102.296,
    height: 76.505,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_77",
    "data-name": "Trazado 77",
    d: "M0,58.573c.249-.894.444-1.808.762-2.678a2.271,2.271,0,0,1,2.159-1.655,33.426,33.426,0,0,0,13.411-3.578c6.856-3.166,13.622-6.527,20.443-9.771A157.345,157.345,0,0,1,76.343,27.718a154.859,154.859,0,0,1,22.718-2.3A3.006,3.006,0,0,1,102.3,27.2v2a8.663,8.663,0,0,0-.191.974,56.854,56.854,0,0,1-7.631,24.381,69.831,69.831,0,0,1-4.9,7.036c-1.7,2.217-2.534,5.478.339,7.909a8.243,8.243,0,0,1,2.663,5.343c.162,1.137-.353,1.713-1.509,1.656s-2.324-.164-3.485-.248L66.473,74.738,45.959,73.27l-21.31-1.527q-9.859-.706-19.717-1.421a3.587,3.587,0,0,1-3.149-2.138,16.441,16.441,0,0,1-.991-2.712C.466,64.254.258,63.005,0,61.77v-3.2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_78",
    "data-name": "Trazado 78",
    d: "M82.1,17.52c.148-2.741-.738-4.161-3.1-5.022a31.392,31.392,0,0,0-8.933-1.475,36.289,36.289,0,0,0-21.09,5.215C38.1,22.623,27.116,28.845,16.83,36.192A4.867,4.867,0,0,0,14.67,39.5c-.382,2.3-.9,4.574-1.248,6.877a2.153,2.153,0,0,1-1.726,2.007c-1.142.315-2.256.732-3.593,1.175.069-.678.083-1.124.163-1.558q.878-4.763,1.779-9.522a9.5,9.5,0,0,1,4.141-6.225c8.036-5.6,16.278-10.871,24.825-15.66,4.006-2.245,7.942-4.63,12.036-6.7A36.655,36.655,0,0,1,70.859,6.377,81.85,81.85,0,0,1,79.327,7.66,12.768,12.768,0,0,1,82.4,8.823a6.341,6.341,0,0,1,3.9,4.825c.441,2.485,1.175,4.919,1.824,7.364.212.8.033,1.138-.828,1.261a17.5,17.5,0,0,1-6.031-.145,52.623,52.623,0,0,0-16.776-.957,35.05,35.05,0,0,0-11.607,3.5q-13.619,6.817-27.21,13.691c-.293.147-.59.287-.892.434A3.071,3.071,0,0,1,26.1,35.066q12.827-7.345,25.659-14.682c6.564-3.739,13.69-4.856,21.115-4.244,2.777.229,5.523.827,8.283,1.255.289.045.58.076.939.123",
    fill: "#fdb54e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_79",
    "data-name": "Trazado 79",
    d: "M25.654,19.826c-.026-.519-.058-.877-.058-1.236,0-4.029.024-8.058-.016-12.086a4.544,4.544,0,0,1,1.526-3.544,11.283,11.283,0,0,1,6.7-2.813A29.739,29.739,0,0,1,38.965.08a3.311,3.311,0,0,1,2.912,2.26c.783,1.873,1.646,3.713,2.5,5.554.268.575.256.954-.356,1.312q-8.84,5.163-17.66,10.359a5.2,5.2,0,0,1-.711.26",
    fill: "#fdb54e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_80",
    "data-name": "Trazado 80",
    d: "M74.108,44.582c0,3.476-2.326,6.293-5.195,6.293s-5.195-2.817-5.195-6.293,2.326-6.293,5.195-6.293,5.195,2.817,5.195,6.293",
    fill: "#20221d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_81",
    "data-name": "Trazado 81",
    d: "M52.73,50.314c0,2.627-1.7,4.756-3.8,4.756s-3.8-2.129-3.8-4.756,1.7-4.756,3.8-4.756,3.8,2.129,3.8,4.756",
    fill: "#20221d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_82",
    "data-name": "Trazado 82",
    d: "M33.549,55.487c0,1.977-1.208,3.579-2.7,3.579s-2.7-1.6-2.7-3.579,1.208-3.579,2.7-3.579,2.7,1.6,2.7,3.579",
    fill: "blue"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83",
    "data-name": "Trazado 83",
    d: "M16.685,59.865c0,1.434-.876,2.6-1.957,2.6s-1.957-1.162-1.957-2.6.876-2.6,1.957-2.6,1.957,1.162,1.957,2.6",
    fill: "blue"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruceroIcon2);
export default __webpack_public_path__ + "static/media/cruceroIcon2.5821256f757b2a1f9e8cf4c4110999d0.svg";
export { ForwardRef as ReactComponent };